import { Reducer } from 'redux'
import { FlyOutProductFormChangeType, FlyoutProductForm } from './action'
import {
  FlyoutListingProductType,
  FlyoutMicrosoftProductSections,
  FlyoutProductSections,
  ProductDefaultInfo,
  ProductInCreation,
  ProductObjectDetail,
  StatusListingResObj,
} from '../../types/addEditProduct'

export {
  FlyoutListingProductType,
  FlyoutProductAddEditSectionName,
  allowedCopyProduct,
  ApplicationAccessMethod,
} from '../../types/addEditProduct'

export type {
  FlyoutProductMigrationDetails,
  FlyoutCloudProductDetails,
  NotificationRecipients,
  ContractDimension,
  FlyoutProductGeneralInformation,
  FreeTrialDimension,
  FlyoutProductFreeTrial,
  FlyoutProductProductDimensions,
  FlyOutProductTerm,
  FlyOutProductTermsAndConditions,
  pageMarkerType,
  FlyOutProductAgreementTerm,
  FlyOutProductAgreement,
  FlyoutProductInfoCollectionFormMetaData,
  TestingCredentials,
  FlyoutProdctRedirectionSettings,
  FlyoutProductBuyerFormFields,
  FlyoutProductSections,
  FlyoutMicrosoftProductSections,
  StatusListingResObj,
  StatusListingItem,
  StatusOfferItem,
  PoductObjectInCreation,
  ProductObjectDetail,
  BuyerFormFieldsBackend,
  ProductDefaultInfo,
  ProductInCreation,
  MigrationProduct,
  MigrationProductsData,
  FlyOutMigrationProducts,
  FlyOutMigrationProductsInfo,
  ProductVisibility,
} from '../../types/addEditProduct'

const initialState: ProductInCreation = {
  currentProductInCreation: {
    productForm: {} as FlyoutProductSections,
    microsoftProductForm: {} as FlyoutMicrosoftProductSections,
    listingType: FlyoutListingProductType.NEW,
    errorOnSubmit: '',
  },
  currentProductDetail: {
    productForm: {} as FlyoutProductSections,
    listingType: FlyoutListingProductType.NEW,
    status: '',
    auditJson: {} as StatusListingResObj,
    productName: '',
    marketplaceUrl: '',
    edit: true,
    awsChangeSetStatus: '',
    error: '',
  },
}

type actionType =
  | {
      type: FlyoutProductForm.SET_FLYOUT_PRODUCT_FORM
      payload: FlyoutProductSections
    }
  | {
      type: FlyoutProductForm.SET_FLYOUT_MICROSOFT_PRODUCT_FORM
      payload: FlyoutMicrosoftProductSections
    }
  | {
      type: FlyoutProductForm.SET_FLYOUT_PRODUCT_DETAIL_FORM
      payload: ProductObjectDetail
    }
  | {
      type: FlyoutProductForm.UPDATE_FLYOUT_PRODUCT_FORM
      payload: FlyOutProductFormChangeType
    }
  | {
      type: FlyoutProductForm.SET_FLYOUT_PRODUCT_LISTING_TYPE
      payload: FlyoutListingProductType
    }
  | {
      type: FlyoutProductForm.SET_ERROR_ON_FINAL_SUBMIT
      payload: string
    }
  | {
      type: FlyoutProductForm.SET_CREATION_OTHER_INFO
      payload: Record<string, unknown>
    }
  | {
      type: FlyoutProductForm.CLEAR_FLYOUT_PRODUCT_DETAIL_FORM
    }
  | {
      type: FlyoutProductForm.SET_DEFAULT_PRODUCT_INFO
      payload: ProductDefaultInfo
    }

export const reducer: Reducer<ProductInCreation, actionType> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case FlyoutProductForm.SET_FLYOUT_PRODUCT_FORM: {
      return {
        ...state,
        currentProductInCreation: {
          ...state.currentProductInCreation,
          productForm: action.payload,
        },
      }
    }
    case FlyoutProductForm.SET_FLYOUT_MICROSOFT_PRODUCT_FORM: {
      return {
        ...state,
        currentProductInCreation: {
          ...state.currentProductInCreation,
          microsoftProductForm: action.payload,
        },
      }
    }
    case FlyoutProductForm.SET_FLYOUT_PRODUCT_DETAIL_FORM: {
      return {
        ...state,
        currentProductDetail: action.payload,
      }
    }
    case FlyoutProductForm.CLEAR_FLYOUT_PRODUCT_DETAIL_FORM: {
      return {
        ...state,
        currentProductDetail: initialState.currentProductDetail,
      }
    }
    case FlyoutProductForm.UPDATE_FLYOUT_PRODUCT_FORM: {
      const { sectionName, keyName, value } = action.payload
      return {
        ...state,
        currentProductInCreation: {
          ...state.currentProductInCreation,
          productForm: {
            ...state.currentProductInCreation.productForm,
            [sectionName]: {
              ...state.currentProductInCreation.productForm[sectionName],
              [keyName]: value,
            },
          },
        },
      }
    }
    case FlyoutProductForm.SET_FLYOUT_PRODUCT_LISTING_TYPE: {
      return {
        ...state,
        currentProductInCreation: {
          ...state.currentProductInCreation,
          listingType: action.payload,
        },
      }
    }
    case FlyoutProductForm.SET_ERROR_ON_FINAL_SUBMIT: {
      return {
        ...state,
        currentProductInCreation: {
          ...state.currentProductInCreation,
          errorOnSubmit: action.payload,
        },
      }
    }
    case FlyoutProductForm.SET_CREATION_OTHER_INFO: {
      return {
        ...state,
        currentProductInCreation: {
          ...state.currentProductInCreation,
          ...action.payload,
        },
      }
    }
    case FlyoutProductForm.SET_DEFAULT_PRODUCT_INFO: {
      return {
        ...state,
        productDefaultInfo: {
          ...state.productDefaultInfo,
          ...action.payload,
        },
      }
    }
    default: {
      return state
    }
  }
}
